import ReactDOM from 'react-dom'
import React, { useEffect, useRef } from 'react'
import { TooltipRenderProps } from 'react-joyride'

import Icon24 from 'builder/components/Icon'
import { JoyRideButtonProps } from 'builder/components/JoyRide/types'

import * as Styles from './styles'

interface IProps {
  skipButtonLabel?: string
  skipProps?: TooltipRenderProps['skipProps']
  skipButtonProps?: JoyRideButtonProps
}
export const SkipButton: React.FC<IProps> = ({ skipButtonLabel, skipButtonProps, skipProps }) => {
  const divRef = useRef(document.createElement('div'))

  useEffect(() => {
    const div = divRef.current
    document.body.appendChild(div)
    return () => div.remove()
  }, [])

  return ReactDOM.createPortal(
    <Styles.SkipButtonContainer>
      <Styles.SkipButton {...skipButtonProps} {...skipProps}>
        {skipButtonLabel}
        <Icon24.RightArrow />
      </Styles.SkipButton>
    </Styles.SkipButtonContainer>,
    divRef.current,
  )
}
